import { __extends } from "tslib";
import React from 'react';
import { Modal, MessageBoxFunctionalLayout } from 'wix-style-react';
var CheckAppStatusModal = /** @class */ (function (_super) {
    __extends(CheckAppStatusModal, _super);
    function CheckAppStatusModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleMessage = function (msg) {
            if (msg.data.type === 'APP_INSTALLATION_FINISHED' ||
                msg.data.type === 'CONSENT_USER_CANCELED' ||
                msg.data.type === 'FINISH_INSTALLATION_EMBEDDED') {
                _this.props.closeModal();
            }
        };
        return _this;
    }
    CheckAppStatusModal.prototype.componentDidMount = function () {
        var _this = this;
        window.addEventListener('message', function (msg) {
            _this.handleMessage(msg);
        });
    };
    CheckAppStatusModal.prototype.componentWillUnmount = function () {
        window.removeEventListener('message', this.handleMessage);
    };
    CheckAppStatusModal.prototype.render = function () {
        var checkStatusUrl = this.props.checkStatusUrl;
        return (React.createElement(Modal, { isOpen: true },
            React.createElement(MessageBoxFunctionalLayout, { title: "", theme: "blue", width: "800px", noBodyPadding: true, hideFooter: true, onClose: this.props.closeModal },
                React.createElement("iframe", { src: checkStatusUrl, width: "100%", height: "700px", frameBorder: "0" }))));
    };
    return CheckAppStatusModal;
}(React.Component));
export { CheckAppStatusModal };
//# sourceMappingURL=check-app-status-modal.js.map